import React from 'react';
import useFormValues from '../../common/hook/queries/useFormValues';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import { ReviewStatus } from '../../common/types/ReviewDetailTypes';
import './CsReviewDetailNavbar.scss';

const CsReviewDetailNavbar = (props) => {
  const { onClick, canPointRetrieved } = props;
  const { status } = useFormValues();

  return (
    <FixedBottomNavBar className="cs-review-detail-navbar">
      <div className="button-group">
        {status === ReviewStatus['DELETED_FROM_ADMIN'] && canPointRetrieved && (
          <Button
            color="primary"
            text="포인트 회수"
            onClick={(e) => {
              e.preventDefault();
              onClick();
            }}
          />
        )}
        <Button color="primary" text="저장하기" type="submit" form="update-review-form" />
      </div>
    </FixedBottomNavBar>
  );
};

export default CsReviewDetailNavbar;
